export const ONBOARDING_ROUTES = [
  '/(onboarding)/step-1-about-you',
  '/(onboarding)/step-2-connect',
  '/(onboarding)/step-3-transactions',
  '/(onboarding)/step-4-income',
  '/(onboarding)/step-5-budget',
  '/(onboarding)/step-6-family',
  '/(onboarding)/step-7-life-events',
  '/(onboarding)/step-8-calculating',
] as const;

export const ONBOARDING_TRIAL_ACTIVATION_ROUTE = '/(onboarding)/trial-activation' as const;

export const ONBOARDING_STEP_VALUES = [1, 2, 3, 4, 5, 6, 7, 8] as const;

export type OnboardingRoute = (typeof ONBOARDING_ROUTES)[number];

export const ONBOARDING_TOTAL_STEPS = ONBOARDING_ROUTES.length;
export const ONBOARDING_COMPLETE_STEP = 9;
// Completing the first visible onboarding screen stores step 2.
export const ONBOARDING_STARTED_STEP = 2;
export const FIRST_ONBOARDING_STEP = 1;
export const LAST_ONBOARDING_STEP = 8;
export const LAST_ONBOARDING_STEP_INDEX = ONBOARDING_TOTAL_STEPS - 1;

export function isOnboardingComplete(step: number | null | undefined): boolean {
  return (step ?? 0) >= ONBOARDING_COMPLETE_STEP;
}

export function getOnboardingStepValueForVisibleIndex(index: number): number {
  const clampedIndex = Math.max(0, Math.min(index, LAST_ONBOARDING_STEP_INDEX));
  return ONBOARDING_STEP_VALUES[clampedIndex] ?? FIRST_ONBOARDING_STEP;
}

export function getOnboardingRouteForStep(
  step: number | null | undefined,
): OnboardingRoute | '/(app)' {
  if (isOnboardingComplete(step)) {
    return '/(app)';
  }

  const normalizedStep = Math.max(
    FIRST_ONBOARDING_STEP,
    Math.min(step ?? FIRST_ONBOARDING_STEP, LAST_ONBOARDING_STEP),
  );
  const index = ONBOARDING_STEP_VALUES.findIndex((value) => value === normalizedStep);

  return ONBOARDING_ROUTES[index >= 0 ? index : 0] ?? ONBOARDING_ROUTES[0];
}
